import React, { useEffect, useState } from "react";

import {
    Box,
    CircularProgress,
    Paper,
    Stack,
    Typography,
    Chip
} from "@mui/material";

import AxiosInstance from "../../../services/AxiosInstance";
import { CHANGE_ACTIVITY_URL } from "../../../Constants/Constants";

const ActivityTab = ({
    change
}) => {

    const [activities, setActivities] =
        useState([]);

    const [loading, setLoading] =
        useState(true);


    useEffect(() => {

        const loadActivity = async () => {

            try {

                const response =
                    await AxiosInstance.get(
                        `${CHANGE_ACTIVITY_URL}/change/${change.id}`
                    );

                setActivities(
                    response.data?.data ||
                    response.data ||
                    []
                );

            } catch (error) {

                console.error(
                    "Unable to load change activity",
                    error
                );

            } finally {

                setLoading(false);
            }
        };


        if (change.id) {
            loadActivity();
        }

    }, [change.id]);


    if (loading) {

        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    p: 5
                }}
            >
                <CircularProgress />
            </Box>
        );
    }


    return (

        <Box>

            <Typography
                variant="h6"
                fontWeight={600}
                sx={{ mb: 2 }}
            >
                Activity
            </Typography>


            {activities.length === 0 ? (

                <Typography
                    color="text.secondary"
                >
                    No activity available.
                </Typography>

            ) : (

                <Stack spacing={2}>

                    {activities.map(
                        activity => (

                            <Paper
                                key={activity.id}
                                variant="outlined"
                                sx={{ p: 2 }}
                            >

                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="flex-start"
                                >

                                    <Chip
                                        label={
                                            activity.action ||
                                            "Updated"
                                        }
                                        size="small"
                                    />

                                    <Box>

                                        <Typography
                                            fontWeight={600}
                                        >
                                            {
                                                activity.description ||
                                                activity.message ||
                                                "Change updated"
                                            }
                                        </Typography>

                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                        >
                                            {
                                                activity.createdByName ||
                                                activity.createdBy ||
                                                "-"
                                            }

                                            {" • "}

                                            {
                                                activity.createdOn ||
                                                ""
                                            }
                                        </Typography>

                                    </Box>

                                </Stack>

                            </Paper>

                        )
                    )}

                </Stack>

            )}

        </Box>
    );
};


export default ActivityTab;